import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px 80px 20px;
  position: relative;
  min-width: 1140px;
`;

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 80px;
  padding: 0 20px;
  justify-content: space-between;
  align-items: center;
`;

export const Rectangle = styled.div`
  width: 100%;
  height: 160px;
  background-color: var(--global-color-blue-98);
`;

export const ProfileContainer = styled.div`
  gap: 20px;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 152px;
  align-items: center;
`;

export const ProfileImg = styled.img`
  width: 160px;
  height: 160px;
  background-color: var(--alias-color-background-normal-normal);
  box-shadow: var(--alias-style-shadow-strong);
  border-radius: 24px;
  box-sizing: border-box;
`;

export const ProfileName = styled.div`
  width: 400px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
`;
